import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'findByProperty',
})
export class FindByPropertyPipe implements PipeTransform {
  transform(list: any[] = [], property: string, value: any): any {
    if (!property || value == null) {
      return null;
    }
    // this is necessary because we need to compare both ids and guids
    // and the id value might be stored as numeric or string
    // eslint-disable-next-line eqeqeq
    return list?.find((x) => x[property] == value);
  }
}
